(() => {
  const HOST = 'shopify-forms-embed';
  const FORM = 'form[class*="_formFieldset_"]';

  const STYLES = `
    [class*="_formContainer_"] {
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      overflow: visible;
    }

    ${FORM} {
      box-sizing: border-box;
      width: 100%;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 13px;
      padding: 1px;
    }

    ${FORM} label,
    ${FORM} [class*="_formInputFieldLabel_"],
    ${FORM} [class*="_selectToggleText_"],
    ${FORM} input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
    ${FORM} textarea {
      font-family: Axiforma, sans-serif;
      font-size: 10px;
      font-style: normal;
      font-weight: 375;
      line-height: 119%;
      letter-spacing: 0;
      color: var(--pfm-field-text, #363636);
    }

    ${FORM} [class*="_formInputFieldLabel_"] {
      top: 12px;
    }

    [class*="_formPhoneInputContainer_"] {
      grid-template-columns: 62px minmax(0, 1fr);
      gap: 6px;
    }

    [class*="_arrowDownIcon_"] {
      display: inline-block;
      flex-shrink: 0;
      width: 10px;
      height: 6px;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23363636' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / 10px 6px no-repeat;
    }

    [class*="_arrowDownIcon_"] svg {
      display: none;
    }

    ${FORM} > * {
      grid-column: 1 / -1;
      min-width: 0;
      margin: 0;
    }

    @media screen and (min-width: 600px) {
      ${FORM} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 13px;
      }

      ${FORM} > [data-pfm-half] {
        grid-column: auto;
        align-self: end;
      }

      ${FORM} > [data-pfm-group] {
        grid-column-start: 1;
      }
    }

    ${FORM} > [data-pfm-group] {
      position: relative;
      margin-top: 31px;
    }

    ${FORM} > [data-pfm-group]::before {
    content: attr(data-pfm-group);
    position: absolute;
    left: 0;
    bottom: 100%;
    margin-bottom: 8px;
    font-size: 10px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--pfm-group-label, #a0a7b4);
    pointer-events: none;
    opacity: 25%;
    font-weight: 600;
    font-family: 'Axiforma';
    line-height: 100%;
    }

    ${FORM} input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]) {
      box-sizing: border-box;
      height: 36px;
      padding-top: 16px;
      padding-bottom: 4px;
    }

    ${FORM} button[class*="_selectToggle_"] {
      box-sizing: border-box;
      height: 36px;
      max-height: none;
      padding: 0 12px;
    }

    [class*="_optionList_"] {
      padding: 6px;
    }

    [class*="_optionListItem_"] {
      margin-bottom: 2px;
    }

    [class*="_optionListItem_"] > div {
      padding: 8px 10px;
      font-family: Axiforma, sans-serif;
      font-size: 10px;
      font-weight: 375;
      line-height: 119%;
      letter-spacing: 0;
      color: var(--pfm-field-text, #363636);
    }

    [data-pfm-inline-label] [class*="_label_"] {
      position: absolute !important;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0 0 0 0);
      white-space: nowrap;
      border: 0;
    }

    [data-pfm-inline-label] [class*="_selectToggleText_"]:empty::before {
      content: attr(data-pfm-placeholder);
      color: var(--form-placeholder-color);
    }

    ${FORM} textarea {
      box-sizing: border-box;
      min-height: 124px;
      padding-top: 36px !important;
      resize: vertical;
    }

    [class*="_formFieldContainer_"]:has(textarea)::before,
    [class*="_formFieldContainer_"]:has(textarea):focus-within::before,
    [class*="_formFieldContainer_"]:has(textarea) [class*="_inputFilled_"]::before {
      top: 1px;
      left: 1px;
      right: 14px;
      height: 26px;
    }

    [class*="_formFieldContainer_"]:has(textarea) [class*="_formInputFieldLabel_"] {
      transform: none !important;
    }

    [class*="_formPhoneInputContainer_"] button[class*="_selectToggle_"] {
      gap: 6px;
      padding: 0 10px;
    }

    [class*="_flagIcon_"] {
      flex-shrink: 0;
      width: 20px;
      height: 14px;
      object-fit: cover;
      border-radius: 2px;
    }

    ${FORM} > fieldset[class*="_checkboxFieldSet_"] {
      min-width: 0;
      margin: 6px 0 0;
      padding: 0;
      border: 0;
    }

    fieldset[class*="_checkboxFieldSet_"] > legend {
      padding: 0 0 10px;
      font: 600 9px/1.4 Axiforma, sans-serif;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--pfm-group-label, #a0a7b4) !important;
      opacity: 0.25;
    }

    fieldset[class*="_checkboxFieldSet_"] > div {
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 10px 24px;
    }

    @media screen and (min-width: 600px) {
      fieldset[class*="_checkboxFieldSet_"] > div {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }

    fieldset[class*="_checkboxFieldSet_"] label[class*="_checkboxField_"] {
      grid-template-columns: 12px minmax(0, 1fr);
      gap: 8px;
      cursor: pointer;
    }

    fieldset[class*="_checkboxFieldSet_"] label span {
      font: 375 10px/119% Axiforma, sans-serif;
      color: var(--pfm-field-text, #363636);
    }

    fieldset[class*="_checkboxFieldSet_"] input[type="checkbox"] {
      width: 12px;
      height: 12px;
      margin: 0;
      border: 1px solid var(--pfm-field-text, #363636);
      border-radius: 2px;
      background: transparent;
      -webkit-appearance: none;
      appearance: none;
      cursor: pointer;
    }

    fieldset[class*="_checkboxFieldSet_"] input[type="checkbox"]:checked {
      border-color: var(--pfm-button, #0a3d8f);
      background: var(--pfm-button, #0a3d8f) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 8' fill='none'%3E%3Cpath d='M1 4l2.5 2.5L9 1' stroke='white' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / 8px 7px no-repeat;
    }

    fieldset[class*="_checkboxFieldSet_"] input[type="checkbox"]:focus-visible {
      outline: 2px solid var(--pfm-button, #0a3d8f);
      outline-offset: 2px;
    }

    [class*="_formBannerContainer_"] {
      margin: 0;
      padding: 24px 4px;
      text-align: center;
    }

    [class*="_formBannerContainer_"] [class*="_formBannerHeading_"] {
      display: block;
      margin: 0 0 8px;
      font: 400 18px/1.3 Axiforma, sans-serif;
      color: var(--pfm-field-text, #363636);
    }

    [class*="_formBannerContainer_"] [class*="_textBody_"],
    [class*="_formBannerContainer_"] p {
      font: 375 12px/1.7 Axiforma, sans-serif;
      color: var(--pfm-field-muted, #8a93a3);
    }

    ${FORM} textarea::placeholder {
      font-size: 11px;
      color: var(--pfm-field-muted, #8a93a3);
      opacity: 1;
    }

    /* iOS Safari zooms the page when a focused field is under 16px. */
    @supports (-webkit-touch-callout: none) {
      ${FORM} input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
      ${FORM} textarea,
      ${FORM} select,
      ${FORM} [class*="_selectToggleText_"],
      ${FORM} button[class*="_selectToggle_"],
      [class*="_optionListItem_"] > div {
        font-size: 16px !important;
      }

      ${FORM} textarea::placeholder {
        font-size: 16px !important;
      }

      ${FORM} input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]) {
        height: 48px;
        padding-top: 22px;
      }

      ${FORM} button[class*="_selectToggle_"] {
        height: 48px;
      }

      ${FORM} [class*="_formInputFieldLabel_"] {
        top: 16px;
      }
    }

    ${FORM} > button[class*="_formSubmitButton_"] {
      box-sizing: border-box;
      width: 100%;
      min-height: 36px;
      margin-top: 10px;
      align-items: center;
      font-weight: 500;
    }

    [class*="_formDisclaimer_"] {
      margin: 12px 0 0 !important;
      text-align: left;
      font-size: 10px;
      line-height: 1.6;
      color: var(--pfm-field-muted, #8a93a3);
    }
  `;

  const normalize = (value) =>
    (value || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLowerCase();

  const findSelf = (el, selector) => (el.matches(selector) ? el : el.querySelector(selector));

  const toList = (value) => (value || '').split(',').map(normalize).filter(Boolean);

  const setAttr = (el, name, value) => {
    if (value === null || value === false) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
    } else if (el.getAttribute(name) !== String(value)) {
      el.setAttribute(name, value);
    }
  };

  const addStyles = (root) => {
    try {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(STYLES);
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    } catch (error) {
      const style = document.createElement('style');
      style.textContent = STYLES;
      root.appendChild(style);
    }
  };

  class PartnerAppForm {
    constructor(app) {
      this.app = app;
      this.full = toList(app.dataset.pfmFull);
      this.groupLabel = (app.dataset.pfmGroup || '').trim();
      this.groupBefore = normalize(app.dataset.pfmGroupBefore);
      this.hint = (app.dataset.pfmHint || '').trim();
      this.roots = new Set();

      this.findHosts = this.findHosts.bind(this);
      this.observer = new MutationObserver(this.findHosts);
      this.observer.observe(app, { childList: true, subtree: true });
      if (window.customElements) customElements.whenDefined(HOST).then(this.findHosts);
      this.findHosts();
    }

    findHosts() {
      this.app.querySelectorAll(HOST).forEach((host) => this.attach(host));
    }

    attach(host) {
      const root = host.shadowRoot;
      if (!root || this.roots.has(root)) return;
      this.roots.add(root);
      addStyles(root);

      const run = () => this.decorate(root);
      const rootObserver = new MutationObserver(run);
      rootObserver.observe(root, { childList: true, subtree: true });
      this.rootObservers = [...(this.rootObservers || []), rootObserver];
      run();
    }

    labelFor(root, item) {
      const field = item.querySelector(
        'textarea, input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])'
      );
      if (field && field.getAttribute('aria-label')) return field.getAttribute('aria-label');
      if (field && field.id) {
        const label = root.querySelector(`label[for="${CSS.escape(field.id)}"]`);
        if (label) return label.textContent;
      }
      const label = item.querySelector('label, [class*="_label_"]');
      return label ? label.textContent : '';
    }

    decorate(root) {
      const form = root.querySelector(FORM);
      if (!form) return;

      Array.from(form.children).forEach((item) => {
        if (item.matches('button')) return;

        const hasArea = !!item.querySelector('textarea');
        const hasInput = !!item.querySelector(
          'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])'
        );
        const select = !hasInput && !hasArea ? findSelf(item, '[class*="_selectContainer_"], button[class*="_selectToggle_"]') : null;
        if (!hasArea && !hasInput && !select) return;

        const key = normalize(this.labelFor(root, item));

        setAttr(item, 'data-pfm-half', !hasArea && !this.full.includes(key) ? '' : null);
        setAttr(item, 'data-pfm-group', this.groupLabel && key && key === this.groupBefore ? this.groupLabel : null);

        if (select) {
          const text = item.querySelector('[class*="_selectToggleText_"]');
          const label = item.querySelector('[class*="_label_"]');
          if (text && label && (item.hasAttribute('data-pfm-inline-label') || text.textContent.trim() === '')) {
            setAttr(text, 'data-pfm-placeholder', label.textContent.trim());
            setAttr(item, 'data-pfm-inline-label', '');
          }
        }

        if (hasArea && this.hint) {
          const area = item.querySelector('textarea');
          if (!area.getAttribute('placeholder')) area.setAttribute('placeholder', this.hint);
        }
      });
    }

    destroy() {
      this.observer.disconnect();
      (this.rootObservers || []).forEach((observer) => observer.disconnect());
    }
  }

  const instances = new WeakMap();

  const init = (scope = document) => {
    scope.querySelectorAll('.pfm__app--styled').forEach((app) => {
      if (!instances.has(app)) instances.set(app, new PartnerAppForm(app));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.pfm__app--styled').forEach((app) => {
      if (instances.has(app)) {
        instances.get(app).destroy();
        instances.delete(app);
      }
    });
  });
})();
